import { render, staticRenderFns } from "./ActiveTournamentGameModule.vue?vue&type=template&id=712f89ca&"
import script from "./ActiveTournamentGameModule.vue?vue&type=script&lang=js&"
export * from "./ActiveTournamentGameModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports